export const VERSION = {
  PROD: 'V. 4.0.0',
  QA: 'V. 5.25.3 (QA)',
}
